<div class="container-fluid">
    <div class="row mygrid">
        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 pull-right ad">
            <div *ngFor="let p of photosR" class="imgHolder">
                <img id="{{p.id}}" [src]="photoUrl + p.fileName" class="img-responsive imgMy" (click)="imgClick($event)">
            </div>
        </div>

        <div class="col-lg-2 col-md-2 col-xs-2 col-sm-2 pull-right">
            <router-outlet></router-outlet>
        </div>

        <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 ad">
            <div *ngFor="let p of photosL" class="imgHolder">
                <img id="{{p.id}}" [src]="photoUrl + p.fileName" class="img-responsive imgMy" (click)="imgClick($event)">
            </div>
        </div>

    </div>
</div>

